import { environment } from 'src/environments/environment';

export function serviceURL(server: string, path: string): string {
  return `${environment[server + '_URL'] as string}${path}`;
}
